import React, { useContext, useLayoutEffect, useState } from 'react';

import * as S from './styles';
import SimpleInput from 'components/SimpleInput';
import { PriceTagProps } from 'types/PriceTagProps';
import { getCollection } from './reqs';
import useDebounce from 'hooks/useDebounce';
import { CollectionProps } from 'types/CollectionProps';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';

interface SearchByPriceTagProps {
	dataForm: PriceTagProps;
	setDataForm: React.Dispatch<React.SetStateAction<PriceTagProps>>;
}

export default function SearchByPriceTag({
	setDataForm,
	dataForm
}: SearchByPriceTagProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setMessage, setIsOpenLoad } = useContext(LoadGeneralContext);

	const [wordToSearch, setWordToSearch] = useState('');
	const [options, setOptions] = useState<CollectionProps[]>([]);
	const [isOpen, setIsOpen] = useState(false);
	const [canReq, setCanReq] = useState(false);
	const [stopWatchCluster, setStopWatchCluster] = useState(false);

	const wordToSearchDebounced = useDebounce(wordToSearch, 1000);

	function selectOption(option: CollectionProps) {
		setDataForm((obj) => ({
			...obj,
			vtex_cluster_name: option.name,
			vtex_cluster_id: `${option.id}`
		}));
		setWordToSearch(option.name);
		setIsOpen(false);
		setCanReq(false);
	}

	//busca pela coleção
	useLayoutEffect(() => {
		(async () => {
			if (
				canReq &&
				typeof wordToSearchDebounced === 'string' &&
				wordToSearchDebounced !== ''
			) {
				setMessage('Buscando coleções');
				setIsOpenLoad(true);
				await getCollection(
					wordToSearchDebounced,
					setOptions,
					setIsOpen,
					handleNotify
				);
				setIsOpenLoad(false);
			}

			if (wordToSearchDebounced === '') {
				setDataForm((obj) => ({
					...obj,
					vtex_cluster_name: '',
					vtex_cluster_id: ''
				}));
				setIsOpen(false);
			}
		})();
	}, [wordToSearchDebounced]);

	//se estiver editando aqui salvar o valor
	useLayoutEffect(() => {
		if (!stopWatchCluster && dataForm.vtex_cluster_name !== '') {
			setStopWatchCluster(true);
			setWordToSearch(dataForm.vtex_cluster_name);
		}
	}, [dataForm]);

	return (
		<S.container>
			<SimpleInput
				getValue={(value: string) => {
					setWordToSearch(value);
					setCanReq(true);
				}}
				initialValue={wordToSearch}
				label="Coleção"
			/>
			{isOpen && (
				<S.options>
					{options.map((item) => (
						<p onClick={() => selectOption(item)} key={item.id}>
							{item.name}
						</p>
					))}
				</S.options>
			)}
		</S.container>
	);
}
